import companyConfig from 'config/company-config';

export default function getCompanyByHeader(subDomain: string) {
  const input = (subDomain || '').toLowerCase();

  // Convert entries to array and use Array.find (preferred by Airbnb lint)
  const foundEntry = Object.entries(companyConfig).find(
    ([_, config]) => config.match && input.includes(config.match.toLowerCase())
  );

  // If foundEntry exists, return its config; otherwise default
  return foundEntry ? foundEntry[1] : companyConfig.DEFAULT;
}
